export default __webpack_public_path__ + "static/media/14.29fcbec6.jpeg";